var map = {
	"./account-shield.svg": 6415,
	"./alert-yellow.svg": 58277,
	"./alerta-saque.svg": 1592,
	"./cadastrar-paypal.svg": 17787,
	"./carteira-sem-saldo.svg": 22606,
	"./carteira-sem-transacoes.svg": 33877,
	"./carteira-transacao-error.svg": 10736,
	"./checked.svg": 19012,
	"./copy.svg": 15441,
	"./dominio-personalizado.svg": 9720,
	"./erro-transfer-pix.svg": 53512,
	"./error-api.svg": 76771,
	"./error-outline.svg": 82267,
	"./error-page.svg": 46843,
	"./extrato-transacoes.svg": 42067,
	"./gift-list-edit.svg": 86995,
	"./key-registered.svg": 88481,
	"./key-validation.svg": 92573,
	"./logo-anel.svg": 65684,
	"./logo-casar.svg": 66419,
	"./moeda.svg": 40934,
	"./painel/Subtract-icon.svg": 93968,
	"./painel/add-circle-icon.svg": 15690,
	"./painel/add-icon.svg": 14835,
	"./painel/alert-icon.svg": 38985,
	"./painel/arrow-down-circle-icon.svg": 12424,
	"./painel/arrow-down-icon.svg": 66176,
	"./painel/arrow-left-icon.svg": 32081,
	"./painel/arrow-right-icon.svg": 4197,
	"./painel/arrow-up-circle-icon.svg": 4551,
	"./painel/arrow-up-icon.svg": 47706,
	"./painel/attention-bold-icon.svg": 49005,
	"./painel/attention-line-icon.svg": 4642,
	"./painel/bank-icon.svg": 1321,
	"./painel/bell-icon.svg": 95149,
	"./painel/block-circle-icon.svg": 6269,
	"./painel/block-icon.svg": 32726,
	"./painel/bullets-icon.svg": 45078,
	"./painel/calendar-details-icon.svg": 43398,
	"./painel/cam-line-icon.svg": 47248,
	"./painel/cashback-icon.svg": 22634,
	"./painel/category-icon.svg": 30710,
	"./painel/chart-icon.svg": 47382,
	"./painel/chat-icon.svg": 60791,
	"./painel/check-borderless-icon.svg": 10412,
	"./painel/check-circle-icon.svg": 26553,
	"./painel/check-circle.svg": 77733,
	"./painel/check-icon.svg": 51813,
	"./painel/check-list-active.svg": 86571,
	"./painel/checkbox-checked-icon.svg": 27170,
	"./painel/checkbox-unchecked-icon.svg": 13523,
	"./painel/checklist-icon.svg": 94296,
	"./painel/chevron-down-icon.svg": 41733,
	"./painel/chevron-left-icon.svg": 12456,
	"./painel/chevron-right-icon.svg": 11601,
	"./painel/chevron-up-icon.svg": 56876,
	"./painel/child-icon.svg": 48879,
	"./painel/circle-bordered.svg": 11990,
	"./painel/close-circle-icon.svg": 82202,
	"./painel/close-icon.svg": 62858,
	"./painel/close.svg": 25938,
	"./painel/cloud.svg": 62719,
	"./painel/config-icon.svg": 99199,
	"./painel/copy-icon.svg": 60755,
	"./painel/couple-icon.svg": 13279,
	"./painel/credit-card-icon.svg": 81033,
	"./painel/dashboard-icon.svg": 70282,
	"./painel/date-icon.svg": 32694,
	"./painel/depositMoney.svg": 95796,
	"./painel/depositMoneyError.svg": 9731,
	"./painel/desktop-icon.svg": 5908,
	"./painel/discount-icon.svg": 80675,
	"./painel/dollar-icon.svg": 19151,
	"./painel/download.svg": 8218,
	"./painel/duplicate-icon.svg": 8011,
	"./painel/edit-line-icon.svg": 87936,
	"./painel/external-link-icon.svg": 87923,
	"./painel/facebook-icon.svg": 1997,
	"./painel/filled-info-icon.svg": 73260,
	"./painel/filter-line-icon.svg": 59370,
	"./painel/flag-icon.svg": 48966,
	"./painel/freeform-icon.svg": 91250,
	"./painel/gift-chargeback-icon.svg": 51891,
	"./painel/gift-icon.svg": 34386,
	"./painel/gift-line-icon.svg": 24736,
	"./painel/gift-pink.svg": 91324,
	"./painel/help-icon.svg": 71451,
	"./painel/icon-about-list.svg": 83914,
	"./painel/icon-config-list.svg": 8859,
	"./painel/icon-edit-list.svg": 83858,
	"./painel/icon-extern-list.svg": 22763,
	"./painel/icon-gift-received.svg": 57298,
	"./painel/icon-transfer.svg": 33171,
	"./painel/icone-pix.svg": 85271,
	"./painel/id-icon.svg": 70290,
	"./painel/info-icon.svg": 24751,
	"./painel/info-modern-icon.svg": 29007,
	"./painel/info-solid.svg": 52137,
	"./painel/landscape-icon.svg": 25216,
	"./painel/list-down-icon.svg": 95931,
	"./painel/list-guest-icon.svg": 18418,
	"./painel/list-up-icon.svg": 89938,
	"./painel/logo.svg": 5103,
	"./painel/mail-icon.svg": 72843,
	"./painel/message-icon.svg": 52754,
	"./painel/mobile-icon.svg": 85211,
	"./painel/money-chargeback-icon.svg": 7295,
	"./painel/money-circle-icon.svg": 73379,
	"./painel/money-icon.svg": 2624,
	"./painel/move-icon.svg": 88852,
	"./painel/next-circle-out-icon.svg": 65569,
	"./painel/notification.svg": 29560,
	"./painel/out-icon.svg": 34975,
	"./painel/paypal-chargeback-icon.svg": 64807,
	"./painel/paypal-icon.svg": 80165,
	"./painel/personalize-icon.svg": 87176,
	"./painel/phone-icon.svg": 16202,
	"./painel/pix-icon-btn.svg": 91621,
	"./painel/pix-icon.svg": 24315,
	"./painel/play-fill-icon.svg": 25860,
	"./painel/play-line-icon.svg": 96461,
	"./painel/plus-circle.svg": 14702,
	"./painel/portait-icon.svg": 93337,
	"./painel/radio-checked-icon.svg": 11171,
	"./painel/radio-icon.svg": 88868,
	"./painel/refund-icon.svg": 57951,
	"./painel/reload-icon.svg": 15856,
	"./painel/rings-icon.svg": 66692,
	"./painel/rsvp-close-icon.svg": 77846,
	"./painel/rsvp-open-icon.svg": 49716,
	"./painel/search-icon.svg": 80813,
	"./painel/setting-icon.svg": 55092,
	"./painel/share-icon.svg": 72903,
	"./painel/shield-icon.svg": 5730,
	"./painel/shopping-chargeback-icon.svg": 76461,
	"./painel/shopping-icon.svg": 65599,
	"./painel/show-icon.svg": 50626,
	"./painel/square-icon.svg": 2597,
	"./painel/star.svg": 44866,
	"./painel/sub-circle.svg": 44229,
	"./painel/tax-zero-icon.svg": 6479,
	"./painel/theme-icon.svg": 27390,
	"./painel/think-icon.svg": 42564,
	"./painel/time-icon.svg": 75450,
	"./painel/transfer-icon.svg": 55327,
	"./painel/trash-icon.svg": 36570,
	"./painel/trash-line-icon.svg": 79844,
	"./painel/upload-icon.svg": 93881,
	"./painel/users-icon.svg": 525,
	"./painel/view-icon.svg": 12497,
	"./painel/wallet.svg": 31966,
	"./painel/warning-outline-icon.svg": 94368,
	"./painel/web-icon.svg": 80881,
	"./painel/whatsapp-icon.svg": 43638,
	"./painel/whatsapp-not-filled-icon.svg": 78846,
	"./painel/zoomin-icon.svg": 89539,
	"./painel/zoomout-icon.svg": 24470,
	"./parceiros-error.svg": 47909,
	"./paypal-white-color.svg": 35319,
	"./paypal-with-error.svg": 63213,
	"./paypal.svg": 25292,
	"./pix.svg": 48331,
	"./postcard.svg": 32808,
	"./rsvp-success-icon.svg": 42545,
	"./saque-indisponivel.svg": 97894,
	"./time-24h.svg": 60999,
	"./time-info.svg": 80577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;